<template>
    <EditModelLayout
        :indexRoute="$route('admin::reminders.index')"
        :updateRoute="$route('admin::reminders.update', { reminder: reminder.id })"
        :modelNameSingular="__('admin::reminders.reminder')"
        :modelNamePlural="__('admin::reminders.reminders')"
        :form="form"
        :name="form.name"
    >

        <FormGroup :label="__('admin::labels.name')" :error="errors.name">
            <Input name="name" type="text" :has-error="exists(errors.name)" v-model="form.name" :required="true" />
        </FormGroup>

        <FormGroup :label="__('admin::labels.frequency')" :error="errors.frequency">
            <Input name="frequency" type="text" :has-error="exists(errors.frequency)" v-model="form.frequency" :required="true" />
            <FrequencyPresets @select="form.frequency = $event" />
        </FormGroup>

    </EditModelLayout>
</template>

<script>
    export default {
        props: {
            errors: Object,
            reminder: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    name: this.reminder.name,
                    frequency: this.reminder.frequency,
                })
            }
        },
    }
</script>
